import { Typography } from "@mui/material";
import React from "react";
import "./chip.css";
import "../pages/analytics/analytics.css";

const CustomChips = ({ width, type, text }) => {
  const getChip = () => {
    if (type === 0) {
      return (
        <div
          className="chip-backgroung-0"
          style={{ width: width ? width : "auto" }}
        >
          <Typography className="labelMedium font-darkRed ">{text}</Typography>
        </div>
      );
    }
    if (type == 1) {
      return (
        <div
          className="chip-backgroung-1"
          style={{ width: width ? width : "auto" }}
        >
          <Typography className="labelMedium font-darkGreen">{text}</Typography>
        </div>
      );
    }
    if (type == 2) {
      return (
        <div
          className="chip-backgroung-2"
          style={{ width: width ? width : "auto" }}
        >
          <Typography className="labelMedium font-darkYellow">
            {text}
          </Typography>
        </div>
      );
    }
  };
  return <>{getChip()}</>;
};

export default CustomChips;
